import { render, staticRenderFns } from "./VenScL_List.vue?vue&type=template&id=3036e302"
import script from "./VenScL_List.vue?vue&type=script&lang=js"
export * from "./VenScL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports